export * from '@fhs/routing/src/routes/v2/cart/index';
export { default } from '@fhs/routing/src/routes/v2/cart/index';
